import React from 'react'

function PaperPlaneIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <path
        stroke="#56565A"
        strokeWidth={1.5}
        d="M19.722 2.905a.996.996 0 0 1 1.515.985l-2.358 16.504a.996.996 0 0 1-1.384.773L3.35 15.008a.996.996 0 0 1-.132-1.758L19.722 2.905Z"
      />
      <path
        stroke="#56565A"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="m9.538 17.703 11.325-14.74"
      />
      <path
        stroke="#56565A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M9.538 17.703v3.547l2.79-2.333"
      />
    </svg>
  )
}
export default PaperPlaneIcon
